<!--
 @description 灰度监控
 @author xiehan
 @date 2019/08/21
-->
<template>
  <div class="grayMonitor__content">
    <div class="grayMonitor__form">
      <el-form ref="searchForm" :model="searchForm" :inline="true">
        <el-form-item :label="$t('grayMonitor.version')">
          <el-input v-model="searchForm.version"></el-input>
        </el-form-item>
        <el-form-item :label="$t('grayMonitor.tag')">
          <el-input v-model="searchForm.tag"></el-input>
        </el-form-item>
        <el-form-item :label="$t('grayMonitor.group')">
          <g-select v-model="searchForm.group" :list="select_group" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('grayMonitor.application')">
          <el-input v-model="searchForm.application"></el-input>
        </el-form-item>
        <el-form-item :label="$t('grayMonitor.hisId')">
          <el-input v-model="searchForm.hisId"></el-input>
        </el-form-item>
        <el-form-item label="IP">
          <el-input v-model="searchForm.ip"></el-input>
        </el-form-item>
        <el-form-item :label="$t('grayMonitor.releaseTime')" input-width="auto">
          <el-form-item prop="startTime">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.startTime" type="datetime">
            </el-date-picker>
          </el-form-item>
          <span v-text="$t('common.to')"></span>
          <el-form-item prop="endTime" style="margin-left: 10px">
            <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.endTime" type="datetime">
            </el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" v-g-rac="gRac('grayMonitor@search')">{{ $t('common.search') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table-extend
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
    </el-table-extend>
  </div>
</template>

<script>
  import table from '@/components/mixins/table'
  import dic from '@/components/mixins/dic'
  import grayConfigBiz from '@/logic/continuousDelivery/grayConfigBiz'
  import { extend } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'
  import rac from '@/plugins/rac-mixin.js'
  export default {
    mixins: [rac, dic, table],
    data () {
      return {
        searchForm: {
          application: '',
          group: '',
          hisId: '',
          tag: '',
          version: '',
          ip: '',
          startTime: new Date().getTime() - 86400000,
          endTime: new Date().getTime()
        },
        select_group: {}
      }
    },
    methods: {
      async preInitTable () {
        await Promise.all([
          this.dGetDictionaryByCode('groupType')
        ])
        this.select_group = { ...this.dDictionary.groupType }
        this.initTable()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'grayMonitor.table',
          head: ['tagId', 'hisId', 'routeVersionName', 'routeVersionGroup', 'tagName', 'routeRuleName', 'routeStrategyName', 'replyApp', 'replyIp', 'publishTime', 'replyDate'],
          requestFun: this.searchTable,
          headOpt: {
            routeVersionGroup: {
              formatter: 'Dictionary',
              formatterDic: this.select_group
            }
          }
        })
        this.searchTable()
      },
      search () {
        this.tResetPage()
        this.searchTable()
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        for (let i in reqData) {
          if (reqData[i] === '') {
            delete reqData[i]
          }
        }
        grayConfigBiz.queryMonitor(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map(item => {
              item.publishTime = item.publishTime ? TimeFormat.getFormatTime(item.publishTime) : ''
              item.replyDate = item.replyDate ? TimeFormat.getFormatTime(item.replyDate) : ''
            })
          }
          this.tData = data
        })
      }
    },
    mounted () {
      this.preInitTable()
    }
  }
</script>

<style scoped>
</style>